import moment, { Moment } from "moment";
import {
    CalendarDrawerContent,
    CalendarDrawerSettings,
    CalendarState,
    MonthDivider,
} from "burde";
import { D3Selection } from "./draw-calendar";
import {
    CalendarSizeDimensions,
    Page,
    PageSelector,
    SvgId,
} from "svg/constants";
import drawDynamicExtraPage from "./draw-dynamic-extra-page";
import { drawBorder } from "./draw-border";

const isStartOfMonth = (atDate: moment.Moment, endDate: moment.Moment) => {
    const startOfMonth = atDate
        .clone()
        .add(1, "week")
        .startOf("month")
        .startOf("isoWeek")
        .format("YYYY-MM-DD");

    const start = atDate.clone().startOf("isoWeek").format("YYYY-MM-DD");
    const end = endDate.clone().subtract(1, "week").format("YYYY-MM-DD");

    const isValidMonthlyOccurence =
        start === startOfMonth && startOfMonth !== end;

    if (isValidMonthlyOccurence) {
        return true;
    }

    return false;
};

const getClass = (pageNumber: number) => {
    let page = Page.Odd;
    if (pageNumber % 2 > 0) {
        page = Page.Even;
    }

    return (page === Page.Odd ? PageSelector.Left : PageSelector.Right).replace(
        ".",
        "",
    );
};

const draw = (
    base: D3Selection,
    monthDividerSvg: string,
    pageNumber: number,
    calendarDimensions: CalendarSizeDimensions,
) => {
    const containerId = `svgContainer${pageNumber}`;

    const container = base
        .append("div")
        .attr("id", containerId)
        .attr("class", "svg-container");

    const svg = container
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr(
            "viewBox",
            `0 0 ${calendarDimensions.svgWidth} ${calendarDimensions.svgHeight}`,
        )
        .classed("svg-content", true)
        .attr("id", `${SvgId}${pageNumber}`)
        .attr("xmlns", "http://www.w3.org/2000/svg");

    const content = svg
        .append("g")
        .classed(`main-content ${getClass(pageNumber)}`, true);

    content.append("g").html(monthDividerSvg).classed("svg-content", true);

    content
        .select(".outerContent")
        .attr("height", calendarDimensions.contentHeightWithoutBleeds + 60)
        .attr("width", calendarDimensions.contentWidthWithoutBleeds + 60);

    const innerContentHeight = content
        .select(".innerContent")
        .attr("data-height");
    const innerContentWidth = content
        .select(".innerContent")
        .attr("data-width");

    content
        .select(".innerContent")
        .attr("height", innerContentHeight)
        .attr("width", innerContentWidth);

    return svg;
};

const drawMonthDivider = (
    base: D3Selection,
    monthDivider: MonthDivider,
    pageNumber: number,
    calendarDimensions: CalendarSizeDimensions,
    calendar: CalendarState,
    calendarDrawerSettings: CalendarDrawerSettings,
    Header_WeekNumberPrefix: string,
    atDate: Moment,
    calendarDrawerContent: CalendarDrawerContent,
) => {
    const leftSvg = draw(
        base,
        monthDivider.endpoints.leftPage,
        pageNumber,
        calendarDimensions,
    );

    pageNumber += 1;

    const rightSvg = draw(
        base,
        monthDivider.endpoints.rightPage,
        pageNumber,
        calendarDimensions,
    );

    if (monthDivider.dynamicDates === true) {
        drawDynamicExtraPage(
            leftSvg,
            atDate,
            calendarDrawerContent.metadata,
            calendar.culture,
            Header_WeekNumberPrefix,
        );

        drawDynamicExtraPage(
            rightSvg,
            atDate,
            calendarDrawerContent.metadata,
            calendar.culture,
            Header_WeekNumberPrefix,
        );
    }

    if (calendar.monthDivider !== null && calendar.monthDivider.showFrame) {
        drawBorder(
            leftSvg,
            calendar.borderColor,
            Page.Odd,
            calendar.calendarSize,
            !calendarDrawerSettings.isConfiguratorView,
            calendarDrawerContent,
        );

        drawBorder(
            rightSvg,
            calendar.borderColor,
            Page.Even,
            calendar.calendarSize,
            !calendarDrawerSettings.isConfiguratorView,
            calendarDrawerContent,
        );
    }
};

export { drawMonthDivider, isStartOfMonth };
